import IDream from "motw_core/Entity/IDream";
import * as React from "react";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "../../../../services/UI/State/State";
import Hyperlink from "../../../Shared/Link/Hyperlink";
import { clearedDreamFilters } from "source/app/presentation/MainPanel/Dreams/DreamFilterButtons/Helpers/clearedDreamFilters";
import { IDreamsState } from "../IDreamsState";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";

interface DreamPanelLinkOptions {
    dream: IDream;
    children: any;
    isNotLinked: boolean;
}

function DreamPanelLink({
    dream,
    children,
    isNotLinked,
}: DreamPanelLinkOptions) {
    return (
        <Hyperlink
            whenClicked={() => {
                const dreams = State.ReadClass<IDreamsState>(
                    ESharedComponent.Dreams
                );

                if (isNotLinked) {
                    return;
                }

                const selectedCampaignId = dream.linkid ?? dream.id;

                const dreamFilters = {
                    ...clearedDreamFilters,
                    selectedCampaignId,
                };

                dreams.setState(dreamFilters);
            }}
            classes={StyleClass(`dreamPanelLinkContainer`, {
                flexShrink: 0,
            })}
        >
            {children}
        </Hyperlink>
    );
}

export default DreamPanelLink;
